import { useTranslation } from 'react-i18next';
import { Chip, Tooltip } from '@mui/material';
import {
    HourglassEmpty as HourglassEmptyIcon, Pause as PauseIcon, Check as CheckIcon, Clear as ClearIcon,
    Event as EventIcon
} from '@mui/icons-material';
import { formatDateTime } from '@utils/helpers';

function SendoutStatusChip({ status, missing_credits_type, planned_at, tooltip = true }) {
    const { t } = useTranslation();

    switch (status) {
        case 'InProgress':
            return <Chip size="small" label={t('In progress')} color="primary" icon={<HourglassEmptyIcon />} />;
        case 'Paused':
            return <Chip size="small" label={t('Paused')} color="warning" icon={<PauseIcon />} />;
        case 'PausedMissingCredits':
            return missing_credits_type ? (
                tooltip
                ? (
                    <Tooltip title={
                        t('Sendout has been paused because of missing {{type}} credits.', { type: t(`credit.${missing_credits_type}`) })
                        + ' ' + t('In order to add {{type}} credits, please contact your account manager.', { type: t(`credit.${missing_credits_type}`) })
                    }>
                        <Chip size="small" label={t('Paused ({{type}} credits)', { type: t(`credit.${missing_credits_type}`) })} color="warning" icon={<PauseIcon />} />
                    </Tooltip>
                )
                : <Chip size="small" label={t('Paused ({{type}} credits)', { type: t(`credit.${missing_credits_type}`) })} color="warning" icon={<PauseIcon />} />
            ) : (
                <Chip size="small" label={t('Paused (missing credits)')} color="warning" icon={<PauseIcon />} />
            );
        case 'Planned':
            return <Chip size="small"
                label={planned_at ? t('Planned at {{planned_at}}', { planned_at: formatDateTime(planned_at) }) : t('Planned')}
                color="warning" icon={<EventIcon />} />;
        case 'Completed':
            return <Chip size="small" label={t('Completed')} color="success" icon={<CheckIcon />} />;
        case 'Canceled':
            return <Chip size="small" label={t('Canceled')} color="error" icon={<ClearIcon />} />;
        default:
            return <Chip size="small" label={t('Unknown')} color="default" />;
    }
}

export default SendoutStatusChip;